import React, { useState } from "react";
import { login } from "./utils";

const Log = () => {
	const [usernameL, setUserNameL] = useState("");
	const [passwordL, setpasswordL] = useState("");
	const [msgL, setmsgL] = useState("");
	const [first, setFirst] = useState(false);
	const [togL, setTogL] = useState(true);

	async function Login(e) {
		e.preventDefault();
		if (usernameL.length < 1 || passwordL.length < 1) {
			alert("Fields should not remain blank");
			return;
		}
		//console.log(usernameL, passwordL);
		const data = await login(usernameL, passwordL);
		console.log(data);
		if (data.status == "FAILED") {
			setmsgL(data.error);
			alert("Invalid credentials");
			window.location.reload();
		} else if (data.tokens) {
			setmsgL(`Hello, ${usernameL}`);
			localStorage.setItem(
				"creds",
				JSON.stringify({
					access: data.tokens.access,
					refresh: data.tokens.refresh,
					first: data.first_time_login,
					username: usernameL,
					type: data.type,
				})
			);

			if (data.first_time_login === true) {
				console.log("first time login");
				window.location = `/profile`;
			} else {
				console.log("not first time login");
				if (data.type == "P") {
					window.location = `/patient/home`;
				} else if (data.type == "A") {
					window.location = `/admin/home`;
				} else {
					window.location = `/provider`;
				}
			}
		} else if (data.password) {
			setmsgL("Password :" + data.password[0]);
		} else if (data.username) {
			setmsgL("Username :" + data.username[0]);
		}
	}
	return (
		<>
			<div>
				<div className="outer">
					<div className="inner">
						<form>
							<h3>Log in</h3>
							<div className="form-group">
								<input required onChange={(e) => setUserNameL(e.target.value)} id="login-email" type="text" className="form-control" placeholder="Username" required />
							</div>
							<div className="form-group">
								<input required onChange={(e) => setpasswordL(e.target.value)} id="login-password" type={togL ? "password" : "text"} className="form-control" placeholder="Password" required></input>
							</div>
							<button onClick={Login} type="submit" className="btn btn-dark btn-lg btn-block" style={{ marginLeft: "37.5%" }}>
								Login
							</button>
						</form>
					</div>
				</div>
			</div>
		</>
	);
};
export default Log;
